import { HTMLAttributes, Ref } from 'react';
import { TooltipCommonProps } from '../common';

export interface DragHandleProps {
  domRef?: Ref<HTMLDivElement>;
  tabIndex?: number;
  onClick?: HTMLAttributes<HTMLDivElement>['onClick'];
  onKeyDown?: HTMLAttributes<HTMLDivElement>['onKeyDown'];
  'aria-label'?: string;
  'aria-describedby'?: string;
  tooltipContent?: string;
  tooltipProps?: Partial<TooltipCommonProps>;
}

export interface DragHandleInternalProps extends DragHandleProps {
  dataHook?: string;
  dragging?: boolean;
  disabled?: boolean;
  onBlur?: HTMLAttributes<HTMLDivElement>['onBlur'];
  onKeyUp?: HTMLAttributes<HTMLDivElement>['onKeyUp'];
  dragHandleSize?: 'small' | 'large';
}
